import React from 'react';
import useImpulseService from './use-impulse-service';

const useCheckIfStem = ({state, serviceId}) => {
    const {serviceById} = useImpulseService({serviceId});
    const [isStemImpulse, setIsStemImpulse] = React.useState();
    
    React.useEffect(() => {
        if (state.length) {
            const endpointIdsInCart = state.map(e => e.endpointId);
            const endpointsInCart = serviceById.endpoints.filter(e => endpointIdsInCart.includes(e.id));
            setIsStemImpulse(endpointsInCart.some(e => e.labels && e.labels.isStem));
        }
    }, [state, serviceById]);
    
    return (
        {
            isStemImpulse
        }
    )
};

export default useCheckIfStem;
